import { memo, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'

import { Box, Flex, useToast } from '@chakra-ui/react'

import { updatePdsr, resetUpdatePdsrOutcome } from '../actions/dsr-actions';
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton'
import { openInNewTab, triggerLaunchdeckToast } from '../../global/helpers/global-helpers'
import { QRCodeSVG } from "qrcode.react";
import config from "../../../config/app-config";
import DsrRoomLogoDisplayModeModule from '../dsr-analytics/DsrRoomLogoDisplayModeModule'
import LaunchdeckSwitch from '../../global/components/helper-components/components/LaunchdeckSwitch'
import useLaunchdeckModal from '../../global/hooks/use-launchdeck-modal'

function DsrProspectRoomSettingsPage({
  // Parent component
  pDsrId,
  dsrProperties,
  // Redux actions
  updatePdsr,
  resetUpdatePdsrOutcome,
  // Redux state
  isMobileView,
  dsrStatusRedux,
  updateProspectDsrOutcome,
  dsrBrandingOptions
}) {

  const toast = useToast();
  const { openLaunchdeckModal } = useLaunchdeckModal();

  const [latestDsrProperties, setLatestDsrProperties] = useState(null)
  const [logoDisplayMode, setLogoDisplayMode] = useState("default")
  const [applyBranding, setApplyBranding] = useState(null)


  const { displayUrl } = config;
  const routeLink = `/pdsr/${pDsrId}`;
  const publishedDsrLinkDisplay = (displayUrl && routeLink) ? `${displayUrl}${routeLink}` : null

  useEffect(() => {
    if (dsrProperties) {
      setLatestDsrProperties(dsrProperties)

      const { applyBranding: applyBrandingSettings, logoDisplayOption } = dsrProperties || {};
      setLogoDisplayMode(logoDisplayOption)
      setApplyBranding(applyBrandingSettings)
    }
  }, [dsrProperties]);

  useEffect(() => {
    if (updateProspectDsrOutcome) {
      const { updatePdsrStatus, updatedPdsrId, sourceEvent } = updateProspectDsrOutcome || {};
      switch (sourceEvent) {
        case ("save-prospect-dsr-properties"): {
          if (updatePdsrStatus && updatedPdsrId === pDsrId && pDsrId !== undefined) {
            toast(
              triggerLaunchdeckToast({
                useCase: "show-success-state",
                // bannerText: "",
                label: "Prospector settings updated",
                isMobileView
              })
            )

          } else if (!updatePdsrStatus) {
            toast(
              triggerLaunchdeckToast({
                useCase: "show-error-state",
                bannerText: "Something went wrong",
                label: "Unfortunately something went wrong. Please try again later.",
                isMobileView
              })
            )
          }

          resetUpdatePdsrOutcome()
          break;
        }
        default: {
          console.log(`There is no such sourceEvent: ${sourceEvent}`)
          break;
        }
      }
    }
  }, [updateProspectDsrOutcome, toast, pDsrId, resetUpdatePdsrOutcome, isMobileView]);


  const handleSaveRoomSettings = (mode, changedValue) => {
    let updatedDsrProperties = "";
    let instantSave = false;

    switch (mode) {
      case ("logo-display-option"): {
        const { option } = changedValue || {}
        if (option) {
          updatedDsrProperties = {
            ...latestDsrProperties,
            logoDisplayOption: option
          }

          instantSave = true;
        }
        break;
      }
      case ("apply-room-branding"): {
        updatedDsrProperties = {
          ...latestDsrProperties,
          applyBranding: !applyBranding
        }

        setApplyBranding(!applyBranding)

        instantSave = true;

        break;
      }
      default: {
        break;
      }
    }

    updatedDsrProperties && setLatestDsrProperties(updatedDsrProperties)

    if (pDsrId && !!instantSave) {
      updatePdsr({
        sourceEvent: "save-prospect-dsr-properties",
        pDsrId: pDsrId,
        dsrProperties: updatedDsrProperties
      })
    }
  }


  return (
    <Box>
      <Flex justify='space-between' align='center'>
        <Box>
          <Box color='brandDark.500' fontSize='1.5em' lineHeight='1.4em' fontWeight='600'>Prospector settings</Box>
          <Box color='brandDark.500' fontSize={['0.75em', '0.875em']} fontWeight='400'>
            Manage Prospector settings here
          </Box>
        </Box>
      </Flex>

      <Box bg='white' p='1em' rounded='0.5em' border='1px solid' borderColor='gray.300' my='1.5em'>
        <Box color='brandDark.500' fontSize='1.25em' lineHeight='1.375em' mb='1em'>Display options</Box>
        <DsrRoomLogoDisplayModeModule
          handleSaveRoomSettings={handleSaveRoomSettings}
          logoDisplayOption={logoDisplayMode}
        />

        <Flex w='100%' justify='space-between' align='center' py='1.5em'>
          <Box>
            <Box lineHeight='1.25em' fontWeight='500'>
              Branding colors
            </Box>
            <Box fontSize='0.75em' lineHeight='1.25em' fontWeight='400' color='gray.500' mt='0.2em'>
              Apply your brand colors to the Prospector
            </Box>
          </Box>
          <Flex pr='0.5em'>
          {dsrBrandingOptions ?
            <LaunchdeckSwitch
              name="applyRoomBranding"
              isChecked={applyBranding}
              onChange={() => handleSaveRoomSettings("apply-room-branding", {})}
              yesContent='"On"'
              noContent='"Off"'
              yesBg="brandDark.500"
              noBg=""
            />
            :
            <LaunchdeckButton onClick={()=>openInNewTab(`${config.displayUrl}/profile?section=1`)} bg='gray.100' color='brandDark.500' label='Not set' />
          }

          </Flex>
        </Flex>
      </Box>


      {dsrStatusRedux === "active" &&
        <Box bg='white' p='1em' rounded='0.5em' border='1px solid' borderColor='gray.300' my='1.5em'>
          <Box color='brandDark.500' fontSize='1.25em' lineHeight='1.375em' mb='1em'>Room QR code</Box>
          <Box display='flex' width='100%' justifyContent='center' my='2em'>
            <QRCodeSVG value={publishedDsrLinkDisplay ? publishedDsrLinkDisplay : ''} />
          </Box>
        </Box>
      }

      <Box bg='white' p='1em' rounded='0.5em' border='1px solid' borderColor='gray.300' my='1.5em'>

        <Box color='brandDark.500' fontSize='1.25em' lineHeight='1.375em' mb='1em'>Unpublish Room</Box>

        <Flex w='100%' direction={['column', 'column', 'row', 'row']} justify='space-between' align='center' py={['0.5em', '0.5em', '1.5em', '1.5em']}>
          <Box w='100%'>
            <Box lineHeight='1.25em' fontWeight='500'>
              Revert back to draft state
            </Box>
            {dsrStatusRedux === "active" ?
              <Box fontSize='0.75em' lineHeight='1.25em' fontWeight='400' color='gray.500' mt='0.2em' pr='1em'>
                Content is retained, members will be unable to access the Room until you re-publish it again
              </Box> :
              <Box fontSize='0.75em' lineHeight='1.25em' fontWeight='400' color='gray.500' mt='0.2em'>
                Room is currently unpublished
              </Box>}
          </Box>

          {dsrStatusRedux === "active" ?
            <Box mt={['2em', '2em', '0', '0']}>
              <LaunchdeckButton bg='brandDark.500' color='white' onClick={() => {
                openLaunchdeckModal('unpublish-prospect-dsr')
              }} label='Unpublish' />
            </Box>
            :
            <Box mt={['2em', '2em', '0', '0']} >
              <LaunchdeckButton dummy={true} bg='gray.100' color='gray.500' label='Unpublish' />
            </Box>
          }


        </Flex>
      </Box>

      <Box bg='white' p='1em' rounded='0.5em' border='1px solid' borderColor='gray.300' my='1.5em'>
        <Box color='brandDark.500' fontSize='1.25em' lineHeight='1.375em' mb='1em'>Danger Zone</Box>

        <Flex w='100%' direction={['column', 'column', 'row', 'row']} justify='space-between' align='center' py={['0.5em', '0.5em', '1.5em', '1.5em']}>
          <Box w='100%'>
            <Box lineHeight='1.25em' fontWeight='500'>
              Delete this Prospector
            </Box>
            <Box fontSize='0.75em' lineHeight='1.25em' fontWeight='400' color='gray.500' mt='0.2em'>
              This action cannot be undone
            </Box>
          </Box>

          <Box mt={['2em', '2em', '0', '0']}>
            <LaunchdeckButton bg='gray.100' color='#DA3739' onClick={() => {
              openLaunchdeckModal('delete-prospect-dsr')
            }} label='Delete' />
          </Box>


        </Flex>
      </Box>


    </Box>

  )

}

const mapStateToProps = (state) => {
  return {
    dsrStatusRedux: state.dsrStatus.status,
    updateProspectDsrOutcome: state.updateProspectDsrOutcome.results.data,
    dsrBrandingOptions: state.dsrBrandingOptions.results,
    isMobileView: state.mobileViewMode.isMobileView
  }
}


const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updatePdsr,
      resetUpdatePdsrOutcome
    },
    dispatch,
  )

export default memo(withRouter(connect(mapStateToProps, mapDispatchToProps)(DsrProspectRoomSettingsPage)))
